<div class="forgot-password-form" *transloco="let t; prefix: 'login'">
  <form #requestNewPasswordForm="ngForm">
    <!-- EMAIL ADDRESS -->
    <div class="form-group">
      <input type="text" class="form-control" [placeholder]="t('usernamePlaceholder')" name="username" id="username"
        [(ngModel)]="user.username" (ngModelChange)="onUsernameChange($event)" required #username="ngModel" />

      <span *ngIf="username.invalid && (username.dirty || username.touched || formSubmitted)" class="error-note">
        {{ t('fieldRequired') }}
      </span>
      <span *ngIf="inlineErrorMessage" class="error-note">{{ inlineErrorMessage }}</span>
    </div>

    <!-- BUTTONS -->
    <div class="form-group d-flex justify-content-between">
      <button type="button" class="btn btn-cancel btn-big btn-block me-2" (click)="toggleForgotPassword()">
        {{ t('forgotPasswordCancel') }}
      </button>
      <button type="submit" class="btn btn-primary btn-big btn-block" (click)="requestNewPassword()">
        {{ t('forgotPasswordRequest') }}
      </button>
    </div>
  </form>
</div>